import * as messages from './i18n/ja';
import i18n from 'i18n';
import { forEach } from 'lodash';

export const minLength = min => value =>
  value && value.length >= min ? undefined : messages.minLength(min);

export const maxLength = max => value =>
  value.length <= max ? undefined : messages.maxLength(max);

export const justLength = just => value =>
  value && value.length === just ? undefined : messages.justLength(just);

export const mustBeNumber = value =>
  isNaN(+value) ? i18n.t('common:validationMessages.mustBeNumber') : undefined;

export const required = value =>
  value !== 0 && !value
    ? i18n.t('common:validationMessages.required')
    : undefined;

const characterRegex =
  '0-9a-zA-ZＡ-Ｚａ-ｚ０-９\u30a0-\u30ff\u3040-\u309f\u3005-\u3006\u30e0-\u9fcf';

export const characterPattern = value =>
  !new RegExp(`^[${characterRegex} 　-]*$`).test(
    value != null ? '' + value : ''
  )
    ? i18n.t('common:validationMessages.characterPattern')
    : undefined;

export const kanaPattern = value =>
  !/^[a-zA-ZＡ-Ｚａ-ｚ\u30a1-\u30fc 　]*$/.test(value != null ? '' + value : '')
    ? i18n.t('common:validationMessages.kanaPattern')
    : undefined;

export const emailPattern = value =>
  !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
    value != null ? '' + value : ''
  )
    ? i18n.t('common:validationMessages.emailPattern')
    : undefined;

export const holdernamePattern = value =>
  !new RegExp(`^[a-zA-Z ]+$`).test(value != null ? '' + value : '')
    ? i18n.t('common:validationMessages.alphaPattern')
    : undefined;

export const payerNamePattern = value =>
  !new RegExp(`^[a-zA-ZＡ-Ｚａ-ｚ･-ﾟ]+$`).test(value != null ? '' + value : '')
    ? i18n.t('common:validationMessages.payerName')
    : undefined;

export const alphanumericPattern = value =>
  !new RegExp(`^[0-9a-zA-Z]+$`).test(value != null ? '' + value : '')
    ? i18n.t('common:validationMessages.alphanumericPattern')
    : undefined;

export const postcodePattern = value =>
  !/^(?:\d{3}-\d{4}|\d{7})$/.test(value != null ? '' + value : '')
    ? i18n.t('common:validationMessages.postcodePattern')
    : undefined;

export const breakMaxLength = value =>
  String(value).split('\n').length > 10
    ? i18n.t('common:validationMessages.breakMaxLength')
    : undefined;

/**
 * サロゲートペアの文字を弾いた文字列を event にセットする。
 * @param {String} value
 */
export const surrogatePairPattern = value =>
  /([\uD800-\uDBFF][\uDC00-\uDFFF])+/.test(value != null ? '' + value : '')
    ? i18n.t('common:validationMessages.surrogatePairPattern')
    : undefined;

export const maxLengthWithLine = max => value => {
  var result = undefined;
  forEach(value.split('\n'), (line, key) => {
    if (line.length > max) {
      result = messages.maxLengthWithLine(max, key + 1);
      return false;
    }
  });
  return result;
};

export const maxLengthRemovedNewline = max => value => {
  const str = value.replace(/\n/g, '');
  return str.length <= max ? undefined : messages.maxLength(max);
};

export const composeValidators = (...validators) => value => {
  const errors = validators.reduce((errors, validator) => {
    errors.push(validator(value));
    return errors;
  }, []);
  return errors.filter(Boolean).length ? errors : undefined;
};



// WEBPACK FOOTER //
// ./src/validation/validators.js